import {UserService} from './UserService'
import {CompanyService} from './CompanyService'
import {OfficeAddressService} from './OfficeAddressService'
import {EmployeeService} from './EmployeeService'
import {ClientService} from './ClientsService'
import {InvoiceService} from './InvoiceService'
import {CardConfigService} from './CardConfigService'
import {globalActions} from './globalActions'
import {PricingService} from './PricingService'

export const actions = {
    ...globalActions,
    ...UserService,
    ...CompanyService,
    ...OfficeAddressService,
    ...EmployeeService,
    ...ClientService,
    ...InvoiceService,
    ...CardConfigService,
    ...PricingService
};
